export enum LoiCoOwnerIssue {
    None = 0,
    MissingEmail = 1,
    InvalidEmail = 2,
    DuplicateEmail = 3,
    MissingName = 4,
}

export enum LoiSigningMode {
    InVetValue = 0,
    ByEmail = 1,
}

export interface LoiCoOwner {
    rowId: number;
    rowNumber: number;
    name: string | null;
    email: string | null;
    issue: LoiCoOwnerIssue;
}

export interface LoiPrimaryOwner {
    name: string;
    mode: LoiSigningMode;
}

export interface LoiFellowOwner {
    associateMemberId: number;
    name: string;
    email: string;
    hasAccount: boolean;
    isSelected: boolean;
    mode: LoiSigningMode;
}

export interface LoiFellowOwnerSelection {
    associateMemberId: number;
    mode: LoiSigningMode;
}

export interface LoiPreparationRequest {
    selectedRowIds: number[];
    primaryOwnerMode: LoiSigningMode;
    fellowOwners: LoiFellowOwnerSelection[];
}

export interface LoiCoOwnersPreview {
    isTableLinked: boolean;
    isTableFound: boolean;
    isRequestCreated: boolean;
    canPrepare: boolean;
    tableName: string | null;
    coOwners: LoiCoOwner[];
    primaryOwner: LoiPrimaryOwner;
    fellowOwners: LoiFellowOwner[];
}
